import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useMemo, useState } from 'react'
import ECharts from '~/components/echarts'
import AWSEKSDashboardFilters from '~/dashboard/aws_eks_dashboard_filters'
import {
  awsDailyEKSSpendByClusterChartPath,
  awsDailyEKSSpendByClusterNameChartPath,
  awsDailyEKSSpendByDeploymentChartPath,
  awsDailyEKSSpendByNamespaceChartPath,
  awsDailyEKSSpendByNodeChartPath,
  awsDailyEKSSpendByWorkloadChartPath,
  awsDailyEKSSpendByWorkloadTypeChartPath,
} from '~/routes'

export default function AWSEKSDashboardCharts({ organizationId: orgId, ...args }) {
  const [chartParams, setChartParams] = useState({})

  // memoize URLs to prevent rerenders
  const awsDailyEKSSpendByClusterChartUrl = useMemo(() => awsDailyEKSSpendByClusterChartPath(orgId), [orgId])
  const awsDailyEKSSpendByNamespaceChartUrl = useMemo(() => awsDailyEKSSpendByNamespaceChartPath(orgId), [orgId])
  const awsDailyEKSSpendByWorkloadChartUrl = useMemo(() => awsDailyEKSSpendByWorkloadChartPath(orgId), [orgId])
  const awsDailyEKSSpendByWorkloadTypeChartUrl = useMemo(() => awsDailyEKSSpendByWorkloadTypeChartPath(orgId), [orgId])
  const awsDailyEKSSpendByClusterNameChartUrl = useMemo(() => awsDailyEKSSpendByClusterNameChartPath(orgId), [orgId])
  const awsDailyEKSSpendByNodeChartUrl = useMemo(() => awsDailyEKSSpendByNodeChartPath(orgId), [orgId])
  const awsDailyEKSSpendByDeploymentChartUrl = useMemo(() => awsDailyEKSSpendByDeploymentChartPath(orgId), [orgId])

  return (
    <div className='card'>
      <div className='card-body'>
        <AWSEKSDashboardFilters possibleValues={args} organizationId={orgId} setChartParams={setChartParams} />

        <div className='row gy-4'>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days EKS spend by cluster`}
              chartInfoTitle='aws_eks_daily_spend_by_cluster'
              url={awsDailyEKSSpendByClusterChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by namespace`}
              chartInfoTitle='aws_eks_daily_spend_by_namespace'
              url={awsDailyEKSSpendByNamespaceChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by workload`}
              chartInfoTitle='aws_eks_daily_spend_by_workload'
              url={awsDailyEKSSpendByWorkloadChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by workload type`}
              chartInfoTitle='aws_eks_daily_spend_by_workload'
              url={awsDailyEKSSpendByWorkloadTypeChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by cluster name`}
              chartInfoTitle='aws_eks_daily_spend_by_cluster_name'
              url={awsDailyEKSSpendByClusterNameChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by node`}
              chartInfoTitle='aws_eks_daily_spend_by_node'
              url={awsDailyEKSSpendByNodeChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
          <div className='col-sm-6'>
            <ECharts
              title={t`Previous 30 days split-cost EKS spend by deployment`}
              chartInfoTitle='aws_eks_daily_spend_by_deployment'
              url={awsDailyEKSSpendByDeploymentChartUrl}
              params={chartParams}
              showExportButton
            />
          </div>
        </div>

        <div className='row'>
          <div className='footnotes'>
            <p className='small mt-4 pt-4 border-top border-light-subtle'>
              <Trans>UTC time is considered in all of the charts.</Trans>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
